;(function() {
  'use strict'

  statsService.$inject = ["$q", "$rootScope", "AUTH_EVENTS", "userStatsResource", "communityService"];
  angular.module('core.services').service('statsService', statsService)

  /* @ngInject */
  function statsService(
    $q,
    $rootScope,
    AUTH_EVENTS,
    userStatsResource,
    communityService
  ) {
    var loggedIn
    var stats = {}
    var remap = {
      couponCount: 'rewards',
      feedbackCount: 'posts',
      followingCount: 'following',
      notificationCount: 'notifications',
      surveyCount: 'surveys',
    }

    $rootScope.$on(AUTH_EVENTS.loginSuccess, onLogin)
    $rootScope.$on(AUTH_EVENTS.logoutSuccess, onLogout)
    $rootScope.$on(communityService.Events.JOINED, refresh)
    $rootScope.$on(communityService.Events.LEFT, refresh)
    $rootScope.$on('survey:responded', refresh)

    return {
      refresh: refresh,
      get: get,
      reset: reset,
    }

    function onLogin() {
      loggedIn = true
      refresh()
    }

    function onLogout() {
      loggedIn = false
      reset()
    }

    function refresh() {
      return $q(function(resolve, reject) {
        if (!loggedIn) {
          return reject()
        }
        userStatsResource
          .get()
          .success(function(resource, data) {
            transform(data)
            apply(data)
            resolve(data)
          })
          .error(reject)
      })
    }

    function transform(data) {
      var clone = _.clone(data)
      // clean up (dont break references)
      _.each(data, function(value, key) {
        delete data[key]
      })
      // add as new format
      _.each(clone, function(item, key) {
        data[remap[key]] = {
          count: item.count === 0 ? null : item.count,
          unseen: item.presentation === 'highlight',
        }
      })
    }

    function apply(data) {
      // clean up (dont break references)
      _.each(stats, function(value, key) {
        delete stats[key]
      })
      // set data
      _.each(data, function(value, key) {
        stats[key] = value
      })
    }

    function get() {
      return stats
    }

    function reset() {
      apply({})
    }
  }
})()
